export const HeaderData = [
    {
        title: 'Acceuil',
        path: '/',
        cName: 'nav-item',
    },
    {
        title: 'Boutique',
        path: '/shop',
        cName: 'nav-item',
    },
    {
        title: 'A propos',
        path: '/about',
        cName: 'nav-item',
    },
    {
        title: 'Contact',
        path: '/contact',
        cName: 'nav-item',
    },
]
